
export const constants = {
    APP_STORE_URL: process.env.REACT_APP_APP_STORE_URL,
    GOOGLE_PLAY_URL: process.env.REACT_APP_GOOGLE_PLAY_URL,

    FACEBOOK_URL: process.env.REACT_APP_FACEBOOK_URL,
    INSTAGRAM_URL: process.env.REACT_APP_INSTAGRAM_URL,
    TWITTER_URL: process.env.REACT_APP_TWITTER_URL,
    LINKEDIN_URL: process.env.REACT_APP_LINKEDIN_URL
}